import apiClient from "../../../api-client.js";

/** Post a message on a piece thread. */
export const postThreadMessage = async (threadId, content, messageType = "normal") => {
  const response = await apiClient.post("communication/messages/", {
    thread: threadId,
    content,
    message_type: messageType,
  });
  return response.data;
};

export const threadErrorText = (err, fallback) => {
  const data = err?.response?.data;
  if (typeof data?.detail === "string") return data.detail;
  if (typeof data?.error === "string") return data.error;
  const thread = data?.thread;
  if (Array.isArray(thread) && thread[0]) return thread[0];
  if (typeof thread === "string") return thread;
  return fallback;
};
